import { useSmsCampaignDetails } from 'conversations-thread-data/sms/public/hooks';
import { jsx as _jsx } from "react/jsx-runtime";
export const withCampaignName = Component => {
  const ComponentWithCampaignName = props => {
    const contentId = props.message && props.message.contentId;
    const {
      campaignDetails
    } = useSmsCampaignDetails({
      contentId
    });
    const campaignName = campaignDetails && campaignDetails.sms.name;
    return /*#__PURE__*/_jsx(Component, Object.assign({}, props, {
      campaignName: campaignName
    }));
  };
  ComponentWithCampaignName.displayName = `withCampaignName(${Component.displayName})`;
  return ComponentWithCampaignName;
};